import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const Arrow = forwardRef(function Arrow(props, ref) {
    return (jsxs(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, props, { ref: ref, children: [jsx("path", { clipRule: "evenodd", d: "M22 13.0002H3V11.0002H22V13.0002Z", fill: "currentColor", fillRule: "evenodd" }), jsx("path", { clipRule: "evenodd", d: "M23.0087 12.0002L16.5945 18.4144L15.1803 17.0002L20.1803 12.0002L15.1803 7.00015L16.5945 5.58594L23.0087 12.0002Z", fill: "currentColor", fillRule: "evenodd" })] })));
});

export { Arrow as default };
//# sourceMappingURL=Arrow.js.map
